// @flow weak

import React, {
  Component
}                               from 'react';
// static website: uncomment createHashHistory, otherwise uncomment createBrowserHistory
import {
  // BrowserRouter as Router,
  HashRouter as Router,
  Switch,
  Route
}                               from 'react-router-dom';
// static website: uncomment createHashHistory, otherwise uncomment createBrowserHistory
import {
// createBrowserHistory as createHistory,
  createHashHistory as createHistory
}                               from 'history';
import { Provider }             from 'react-redux';
import { syncHistoryWithStore } from 'react-router-redux';
import configureStore           from './redux/store/configureStore';
import asyncComponent            from './components/asyncComponent';
import ScrollTop                from './components/scrollToTop/ScrollToTop';
import Login                    from './views/login/index';
import PageNotFound             from './views/pageNotFound';

// Post-login only — code-split out of the pre-login bundle so an
// unauthenticated visitor never downloads it (see webpack.*.config.js).
const App = asyncComponent(() =>
  import(/* webpackChunkName: "post-login" */ './containers/app/App')
);

export const store           = configureStore();
const history         = createHistory();
const syncedHistory   = syncHistoryWithStore(history, store);

class Root extends Component {
  render() {
    return (
      <Provider store={store}>
        <div>
          <Router history={syncedHistory}>
            <ScrollTop>
                <Switch>
                  <Route exact path="/login" component={Login} />
                  <App />
                  <Route component={PageNotFound} />
                </Switch>
            </ScrollTop>
          </Router>
        </div>
      </Provider>
    );
  }

  requireAuth(nextState, replace) {
    console.log("Authentication required");
    if (true) {
      replace({
        pathname: '/login'
      })
    }
  }


}

export default Root;



// WEBPACK FOOTER //
// ./src/app/Root.js